import React from 'react'
import {
  Grid,  Typography, FormControlLabel, Checkbox, Link, Button, Divider } from '@mui/material'
import { Link as RouterLink } from 'react-router'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

// Import shared components
import EmailInput from '../../FormComponents/EmailInput'
import PasswordInput from '../../FormComponents/PasswordInput'
import NameInput from '../../FormComponents/NameInput'
import PhoneInput from '../../FormComponents/PhoneInput'
import PaymentForm from '../PaymentForm'

const FormSection = ({
  halfSizeName = false,
  email,
  setEmail,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  phoneNumber,
  setPhoneNumber,
  password,
  setPassword,
  passwordMask,
  setPasswordMask,
  signUpError }) => {
  return (
    <Grid container direction="row" spacing={2}>
      <Grid size={{xs: 12, sm: halfSizeName ? 6 : 12}}>
        <NameInput
          value={firstName}
          setValue={setFirstName}
          label="First Name"
          placeholder="First Name"
        />
      </Grid>
      <Grid size={{xs: 12, sm: halfSizeName ? 6 : 12}}>
        <NameInput
          value={lastName}
          setValue={setLastName}
          label="Last Name"
          placeholder="Last Name"
        />
      </Grid>
      <Grid size={12}>
        <PhoneInput
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
        />
      </Grid>
      <Grid size={12}>
        <EmailInput
          email={email}
          setEmail={setEmail}
          error={signUpError}
          helperText={signUpError?.message}
        />
      </Grid>
      <Grid size={12}>
        <PasswordInput
          password={password}
          setPassword={setPassword}
          passwordMask={passwordMask}
          setPasswordMask={setPasswordMask}
        />
      </Grid>
    </Grid>
  )
}

export default FormSection
